import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-charge-wallet',
  templateUrl: './charge-wallet.component.html',
  styleUrls: ['./charge-wallet.component.scss']
})
export class ChargeWalletComponent implements OnInit {
  selectedTab: string;
  showTabContent:boolean = false;
  selectRewardForm:FormGroup;

  constructor() { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(){
    this.selectRewardForm = new FormGroup({
      selectedReward: new FormControl('', [Validators.required]),
     });
  }
  selectShipping(type) {
    this.selectedTab = type;
  }

  tabClick(){
    this.showTabContent = !this.showTabContent; 
  }

  onSubmit(){
  }
}
